import FormContainer from "../../../../components/formContainer/FormContainer";
import InputWrapper from "../../../../components/input/wrapper/InputWrapper";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import Select from "../../../../components/select/main/Select";
import { useLanguageContext } from "../../../../context/LanguageContext";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import AccessCommander2NConfigsDataTable from "../../../../components/dataTable/tables/AccessCommander2NConfigsDataTable";
import { useTheme } from "styled-components";

function AccessCommander2NConfigsPageView({
  accessCommander2NConfigData,
  onPincodeChange,
  onActiveChange,
  onSubmit,
  submitError,
}) {
  const { translate } = useLanguageContext();
  const theme = useTheme();

  return (
    <StyledFlexColumn style={{ gap: theme.spacing.large }}>
      <OverlayLoader groups="access_commander_2n_configs_page_fetch">
        <FormContainer
          onSubmit={onSubmit}
          submitError={submitError} 
          submitLoadingGroup={"access_commander_2n_configs_page_save"}
        >
          <StyledFlexColumn>
            <InputWrapper
              label={translate("eva.main.validation.attributes.active")}
              required
              error={EVAApiHelper.getResponseError("active", submitError)}
            >
                <Select
                  options={[
                    { value: true, label: translate("eva.main.general.yes") },
                    { value: false, label: translate("eva.main.general.no") },
                  ]}
                  value={accessCommander2NConfigData.active}
                  onChange={onActiveChange}
                />
            </InputWrapper>

            <InputWrapper
              label={translate("eva.main.validation.attributes.pincode")}
              error={EVAApiHelper.getResponseError("pincode", submitError)}
            >
              <Select
                options={[
                  { value: true, label: translate("eva.main.general.yes") },
                  { value: false, label: translate("eva.main.general.no") },
                ]}
                value={accessCommander2NConfigData.pincode}
                onChange={onPincodeChange}
              />
            </InputWrapper>
          </StyledFlexColumn>
        </FormContainer>
      </OverlayLoader>

      <AccessCommander2NConfigsDataTable />
    </StyledFlexColumn>
  );
}

export default AccessCommander2NConfigsPageView;